<template>
  <RouterLink :to="{ name: 'news' }" class="flex items-end">
    <AdvancedTooltip
        theme="blue"
        placement="top"
        title="Releases">
      <div class="relative">
        <IconNews class="-mb-2 mr-0.5" />
        <span v-if="hasNews"
              class="absolute text-white bg-red-500 text-[9px] w-[35px] h-[13px] px-1 rounded cursor-pointer flex justify-center">NEWS</span>
      </div>
    </AdvancedTooltip>
  </RouterLink>
</template>

<script setup lang="ts">
import AdvancedTooltip from "@/components/tooltip/AdvancedTooltip.vue";
import IconNews from "@/components/svg_icons/IconNews.vue";

const props = defineProps({
  hasNews: {
    type: Boolean,
    required: true
  }
})
</script>